module.exports = __webpack_public_path__ + "img/circuit_white.deef0000.svg";